module.exports = __webpack_public_path__ + "static/media/IntroToDesignThinking.c0d13e1f.png";